import Api from '../utils/Api';
import { createNotification } from './notifications';

export const DELETE_SLACK_STATUS_INTEGRATION_REQUEST =
  'DELETE_SLACK_STATUS_INTEGRATION_REQUEST';
export const DELETE_SLACK_STATUS_INTEGRATION_SUCCESS =
  'DELETE_SLACK_STATUS_INTEGRATION_SUCCESS';
export const DELETE_SLACK_STATUS_INTEGRATION_FAILURE =
  'DELETE_SLACK_STATUS_INTEGRATION_FAILURE';
export const DELETE_SLACK_CHAT_INTEGRATION_REQUEST =
  'DELETE_SLACK_CHAT_INTEGRATION_REQUEST';
export const DELETE_SLACK_CHAT_INTEGRATION_SUCCESS =
  'DELETE_SLACK_CHAT_INTEGRATION_SUCCESS';
export const DELETE_SLACK_CHAT_INTEGRATION_FAILURE =
  'DELETE_SLACK_CHAT_INTEGRATION_FAILURE';

const deleteSlackStatusIntegrationRequest = () => ({
  type: DELETE_SLACK_STATUS_INTEGRATION_REQUEST
});

const deleteSlackStatusIntegrationSuccess = data => dispatch => {
  const messages = [{ text: 'Integration removed', type: 'success' }];
  dispatch(createNotification(messages));
  return {
    type: DELETE_SLACK_STATUS_INTEGRATION_SUCCESS,
    data
  };
};

const deleteSlackStatusIntegrationFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: DELETE_SLACK_STATUS_INTEGRATION_FAILURE
    };
  });
};

export const deleteSlackStatusIntegration = teamId => dispatch => {
  dispatch(deleteSlackStatusIntegrationRequest());
  return Api.deleteSlackStatusIntegration(teamId)
    .then(data => dispatch(deleteSlackStatusIntegrationSuccess(data)))
    .catch(error => dispatch(deleteSlackStatusIntegrationFailure(error)));
};

const deleteSlackChatIntegrationRequest = () => ({
  type: DELETE_SLACK_CHAT_INTEGRATION_REQUEST
});

const deleteSlackChatIntegrationSuccess = data => dispatch => {
  const messages = [{ text: 'Integration removed', type: 'success' }];
  dispatch(createNotification(messages));
  return {
    type: DELETE_SLACK_CHAT_INTEGRATION_SUCCESS,
    data
  };
};

const deleteSlackChatIntegrationFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: DELETE_SLACK_CHAT_INTEGRATION_FAILURE
    };
  });
};

export const deleteSlackChatIntegration = teamId => dispatch => {
  dispatch(deleteSlackChatIntegrationRequest());
  return Api.deleteSlackChatIntegration(teamId)
    .then(data => dispatch(deleteSlackChatIntegrationSuccess(data)))
    .catch(error => dispatch(deleteSlackChatIntegrationFailure(error)));
};



// WEBPACK FOOTER //
// ./src/actions/integrations.js